import { render, staticRenderFns } from "./RemoveMemberModal.vue?vue&type=template&id=f3512800&scoped=true&"
import script from "./RemoveMemberModal.vue?vue&type=script&lang=js&"
export * from "./RemoveMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveMemberModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RemoveMemberModal.vue?vue&type=style&index=1&id=f3512800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3512800",
  null
  
)

export default component.exports